import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Tooltip from './Tooltip.component'

import {
  tooltipHorizontalPadding,
  tooltipMaxWidth,
  tooltipMinWidth,
  tooltipLineHeight
} from './Tooltip.styles'

export default class TooltipContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      resized: false,
      width: 0,
      height: 0,
      closeToLeft: props.closeToLeft || false,
      closeToRight: props.closeToRight || false,
      closeToTop: props.closeToTop || false,
      closeToBottom: false,
      moveBy: props.moveBy || 0,
      visible: false
    }

    this.refText = null
    this.refTextInner = null
    this.refTrigger = null

    this.tooltipHorzMargin = 10
    this.tooltipBorder = 2
    this.horzPaddingBorder = this.tooltipBorder + (tooltipHorizontalPadding * 2)
  }

  onRefText = el => (this.refText = el)
  onRefTextInner = el => (this.refTextInner = el)
  onRefTrigger = el => (this.refTrigger = el)

  componentDidMount() {
    this.initTooltipDimensions()    
  }

  initTooltipDimensions = () => {
    const tooltipSize = this.getTooltipDimensions()

    this.setState({
      width: tooltipSize.width,
      height: tooltipSize.height,
      resized: true
    })
  }

  getTooltipDimensions = () => {
    const approxCharsPerLine = 50 // a rough estimation of number of letters in one line
    const textStringWidth = Math.ceil(this.refTextInner.getBoundingClientRect().width)
    const textLength = this.props.text ? this.props.text.length : 1
    const isTextLessThanMinWidth = textStringWidth < (tooltipMinWidth - this.horzPaddingBorder)
    const isTextMoreThanMaxWidth = textStringWidth > (tooltipMaxWidth - this.horzPaddingBorder)
    const tooltipWidth = isTextMoreThanMaxWidth ? tooltipMaxWidth : isTextLessThanMinWidth ? tooltipMinWidth : textStringWidth + this.horzPaddingBorder
    const numOfLInes = Math.ceil(parseFloat(textLength / approxCharsPerLine))
    const clientAvailableWidth = document.body.clientWidth - (this.tooltipHorzMargin * 2)
    const maximumWidth = tooltipMaxWidth > clientAvailableWidth ? clientAvailableWidth : tooltipMaxWidth

    // keep the tooltip as small as possible if there isn't a full line of text
    // otherwise set it to maximum allowed size
    const elemWidth = numOfLInes === 1 ? tooltipWidth : maximumWidth
    const elemHeight = (numOfLInes * tooltipLineHeight) + this.horzPaddingBorder

    return {
      width: elemWidth,
      height: elemHeight
    }
  }

  // checks if the tooltip extends beyond a window edge end needs to be repositioned
  setTooltipPosition(){
    let { closeToTop, closeToBottom, closeToLeft, closeToRight, moveBy } = this.state

    const clientWidth = document.body.clientWidth
    const tooltipRect = this.refText.getBoundingClientRect()
    const triggerRect = this.refTrigger.getBoundingClientRect()
    const triggerCenter = triggerRect.left + triggerRect.width / 2

    // beyond TOP edge?
    closeToTop = tooltipRect.top < 0

    // beyond BOTTOM edge?
    closeToBottom = tooltipRect.top + tooltipRect.height > window.innerHeight

    // beyond LEFT edge?
    if (triggerCenter < tooltipRect.width / 2) {
      closeToLeft = true
      moveBy = parseInt(tooltipRect.width / 2 - triggerCenter) + this.tooltipHorzMargin
    }
    else{
      closeToLeft = false
    }

    // beyond RIGHT edge?
    if (clientWidth - triggerCenter < tooltipRect.width / 2) {
      closeToRight = true
      moveBy = -parseInt(tooltipRect.width / 2 - (clientWidth - triggerCenter)) + this.tooltipHorzMargin
    }
    else{
      closeToRight = false
    }

    const newState = {}

    let needsUpdate = false

    if( moveBy !== this.state.moveBy ){
      newState.moveBy = moveBy
      needsUpdate = true
    } 
    if( closeToTop !== this.state.closeToTop ){
      newState.closeToTop = closeToTop
      needsUpdate = true
    } 
    if( closeToBottom !== this.state.closeToBottom ){
      newState.closeToBottom = closeToBottom
      needsUpdate = true
    }
    if( closeToLeft !== this.state.closeToLeft ){
      newState.closeToLeft = closeToLeft
      needsUpdate = true
    } 
    if( closeToRight !== this.state.closeToRight ){
      newState.closeToRight = closeToRight
      needsUpdate = true
    }

    if( needsUpdate ){
      this.setState(newState)
    }    

 }  

  mouseEnterHandler = e => {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ visible: true })

    this.setTooltipPosition()

    if (this.props.handleMouseEntered) {
      this.props.handleMouseEntered()
    }
  }

  mouseLeaveHandler = e => {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ visible: false })

    if (this.props.handleMouseLeft) {
      this.props.handleMouseLeft()
    }
  }

  render() {
    const { moveBy, resized, visible, closeToTop, closeToLeft, closeToRight, width: textWidth } = this.state
    const { text, icon, truncate, className, style, textStyle, children, ttWidth: triggerWidth } = this.props

    // Using either the passed prop for trigger width, or the element's width
    const availableWidth = triggerWidth || ( this.refTrigger ? this.refTrigger.offsetWidth : 0 )

    // X position centered
    let x = ( availableWidth - textWidth ) / 2

    // Nudge if positioned at an edge
    if (closeToLeft || closeToRight) {
      x += moveBy * 1.25
    }
    else if (this.props.lastColumn && textWidth === 360) {
      x -= availableWidth * 0.7
    }
    else if (this.props.firstColumn && textWidth === 360) {
      x += availableWidth * 0.3
    }

    const textElementStyle = {
      left: `${x}px`,
      width: `${textWidth}px`
    }

    const triggerStyle = { 
      ...textStyle,
      width: triggerWidth ? `${triggerWidth}px` : 'auto'
    }

    return (
      <Tooltip
        triggerWidth={triggerWidth}
        text={text}
        icon={icon}
        truncate={truncate}
        resized={resized}
        visible={visible}
        className={className}
        style={style}
        triggerStyle={triggerStyle}
        textElementStyle={textElementStyle}
        closeToTop={closeToTop}
        getRefTooltipText={this.onRefText}
        getRefTooltipTextInner={this.onRefTextInner}
        getRefTooltipTrigger={this.onRefTrigger}
        mouseEnterHandler={this.mouseEnterHandler}
        mouseLeaveHandler={this.mouseLeaveHandler}
        triggerElement={this.refTrigger}
      >
        {children}
      </Tooltip>
    )
  }
}


TooltipContainer.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  truncate: PropTypes.bool,
  textStyle: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
}
